import LoginButton from '@/creditflowresearch/ui/common/components/atoms/LoginButton';
import BookDemoButton from '@/creditflowresearch/ui/common/components/atoms/BookDemoButton';

import styles from './userProfileFallback.module.scss';

const UserProfileFallback = () => (
  <div className={ styles.userProfileFallbackContainer }>
    <LoginButton />
    <BookDemoButton />
  </div>
);

export default UserProfileFallback;
